import { createSelector } from 'reselect';
import { PART_COUNT_TYPES } from 'lib/constants';
import { getMachine } from './getMachine';
import { getMachineManualPartCountEnabled } from './getMachineManualPartCountEnabled';
import { getHasOpenActivity } from './getHasOpenActivity';

const getIsMachineManualPartCount = createSelector(
  [getMachine, getMachineManualPartCountEnabled, getHasOpenActivity],
  (machine, machineManualPartCountEnabled, hasOpenActivity) => {
    return (
      machineManualPartCountEnabled &&
      machine?.partCount === PART_COUNT_TYPES.MANUAL_COUNTER.value &&
      hasOpenActivity
    );
  }
);

export { getIsMachineManualPartCount };
